export interface OperationsByHourData {
    hour: string;
    contracts: number;
    redemptions: number;
    prolongations: number;
}

export interface OperationsByEmployeeData {
    employee: string;
    contracts: number;
    redemptions: number;
    prolongations: number;
    total: number;
}

export interface OperationsResponse {
    byHour: OperationsByHourData[];
    byEmployee: OperationsByEmployeeData[];
}

/** Sentinel returned when an operation has no attributable staff member. */
export const UNKNOWN_EMPLOYEE = 'Unknown';

/** Localize the Unknown sentinel; otherwise keep the employee name unchanged. */
export function resolveEmployeeName(employee: string, unknownLabel: string): string {
    return employee === UNKNOWN_EMPLOYEE ? unknownLabel : employee;
}

export interface EmployeePiePoint {
    name: string;
    y: number;
    contracts: number;
    redemptions: number;
    prolongations: number;
}

/** Build employee pie points from total operation counts, dropping empty slices. */
export function buildEmployeePieData(
    data: readonly OperationsByEmployeeData[],
    unknownLabel: string,
): EmployeePiePoint[] {
    return data
        .filter(employee => employee.total > 0)
        .map(employee => ({
            name: resolveEmployeeName(employee.employee, unknownLabel),
            y: employee.total,
            contracts: employee.contracts,
            redemptions: employee.redemptions,
            prolongations: employee.prolongations,
        }));
}

/** True when at least one hour bucket carries a non-zero operation count. */
export function hasHourlyActivity(data: readonly OperationsByHourData[]): boolean {
    return data.some(
        hour => hour.contracts > 0 || hour.redemptions > 0 || hour.prolongations > 0,
    );
}
